// import external modules
import React, { useContext } from "react";
import { withRouter } from 'react-router-dom';
import Auth from "./auth-context";
import Routes from "./Routes";
import { client } from './utils/axios';

const App = props => {
  const auth = useContext(Auth)

  client.interceptors.request.use((config) => {
    const token = auth.isAuthenticated() ? auth.state.access_token : ''
    config.headers.Authorization = `Bearer ${token}`
    return config
  })

  client.interceptors.response.use(null, (err) => {
    // The public docs page (/developers/:secret) lives outside the login gate,
    // so a failed API call must never bounce the visitor to /login.
    if (window.location.pathname.startsWith('/developers/')) {
      return Promise.reject(err)
    }
    if (err.request.status === 401) {
      auth.logout()
      const reason = err.message
      console.warn(reason)
      switch (reason) {
        case 'timeout':
          props.history.push(`/login`);
          break;
        default:
          props.history.push(`/login`);
      }
    }
    if (err.request.status === 404) {
      props.history.push('/login');
    }
    return Promise.reject(err);
  })

  return <Routes />
}

export default withRouter(App)
